const isCart = window.location.search.includes('cartV2.showCart');

const isCheckout = window.location.search.includes('checkoutV2.viewCheckout');

const isProfileSuccess = window.location.search.includes('memberEditAccount.editProfileSuccess');

const isProductDrilldown = !!document.querySelector("meta[property='og:title']");

const isSearchResults = window.location.search.includes('products.search');

const isReceipt = window.location.search.includes('checkoutV2Review.viewReceipt');

const isClubSignupReceipt = window.location.search.includes('clubsV2Review.viewReceipt');

const cameFromCheckout = document.referrer.includes('checkoutV2.viewCheckout');

const cameFromClubSignup = document.referrer.includes('clubsV2SignUp.signUp');

export {
  isCart,
  isCheckout,
  isProductDrilldown,
  isSearchResults,
  isReceipt,
  isProfileSuccess,
  isClubSignupReceipt,
  cameFromCheckout,
  cameFromClubSignup,
};
